export enum Mode {
  JSON = 'json',
  UI = 'ui',
}
